var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M501.912,327.349l-97.414-97.414l-3.787,7.763l-72.614-72.614L214.34,256.286l-100.642,66.145 L299.558,508.29C396.585,491.658,474.952,420.43,501.912,327.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5F1F4"
    },
    d: "M348.522,349.715c40.303,0,72.975-32.671,72.975-72.975c0-40.303-32.671-72.975-72.975-72.975 c-0.56,0-1.112,0.029-1.67,0.043c-7.852-39.407-42.622-69.108-84.335-69.108c-32.134,0-60.132,17.634-74.895,43.741 c-3.639-0.471-7.342-0.738-11.111-0.738c-47.499,0-86.006,38.505-86.006,86.006s38.505,86.006,86.006,86.006H348.522 L348.522,349.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M348.522,203.767c-0.56,0-1.112,0.029-1.67,0.043c-7.852-39.407-42.622-69.108-84.335-69.108 c-2.388,0-4.751,0.109-7.09,0.3v214.712h93.094c40.303,0,72.975-32.671,72.975-72.975 C421.495,236.437,388.823,203.767,348.522,203.767z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FC6F58"
    },
    points: "281.762,267.969 281.762,183.661 230.24,183.661 230.24,267.969 204.479,267.969  256,319.491 307.522,267.969 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1543F"
    },
    points: "307.522,267.969 281.762,267.969 281.762,183.661 255.426,183.661 255.426,318.917  256,319.491 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSvgrepoCom);
export default __webpack_public_path__ + "static/media/download-svgrepo-com.939a6d37b9797e554c5cf12e2d0404eb.svg";
export { ForwardRef as ReactComponent };